const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const concat = Function.bind.call(Function.call, Array.prototype.concat);
const keys = Reflect.ownKeys;

function getValuesFn () {
  if (Object.values) {
    return Object.values;
  } else {
    return function values (O) {
      return reduce(keys(O), (v, k) => concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []), []);
    };
  }
}

function getKeysFn () {
  if (Object.keys) {
    return Object.keys;
  } else {
    return (function () {
      'use strict';
      const hasOwnProperty = Object.prototype.hasOwnProperty;
      const hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
      const dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
      ];
      const dontEnumsLength = dontEnums.length;

      return function (obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        const result = [];

        for (let prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (let i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }
}

export const getValues = getValuesFn();
export const getKeys = getKeysFn();



// WEBPACK FOOTER //
// ./src/utils/objectPolyfill.js